var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevYear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 17,
    height: 17,
    rx: 5,
    transform: "rotate(-180 17 17)",
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3282 12C10.2051 11.9608 10.1184 11.8717 10.0317 11.7808C9.0679 10.7884 8.10405 9.7977 7.14021 8.80881C7.02233 8.68765 6.96685 8.54867 7.02059 8.38296C7.04139 8.3206 7.08127 8.26001 7.12634 8.21369C8.12485 7.18381 9.12511 6.15572 10.1254 5.1294C10.2935 4.95657 10.5119 4.95835 10.6801 5.12584C10.7598 5.20424 10.8396 5.28442 10.9124 5.36995C11.0337 5.51605 11.0268 5.7174 10.9054 5.8635C10.8864 5.88667 10.8656 5.90627 10.8465 5.92765C10.0335 6.76331 9.22045 7.60075 8.40569 8.43641C8.38662 8.45601 8.36408 8.47205 8.32941 8.52016C8.35368 8.53263 8.38142 8.54154 8.39875 8.55936C9.22045 9.40214 10.0404 10.2467 10.8621 11.0913C11.0147 11.2481 11.0459 11.4655 10.9193 11.6134C10.791 11.7648 10.6697 11.9287 10.4755 12C10.4253 12 10.3767 12 10.3282 12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32818 12C7.2051 11.9608 7.11842 11.8717 7.03175 11.7808C6.0679 10.7884 5.10405 9.7977 4.14021 8.80881C4.02233 8.68765 3.96685 8.54867 4.02059 8.38296C4.04139 8.3206 4.08127 8.26001 4.12634 8.21369C5.12485 7.18381 6.12511 6.15572 7.12536 5.1294C7.29351 4.95657 7.51194 4.95835 7.68009 5.12584C7.75983 5.20424 7.83957 5.28442 7.91238 5.36995C8.03373 5.51605 8.0268 5.7174 7.90545 5.8635C7.88638 5.88667 7.86558 5.90627 7.84651 5.92765C7.03348 6.76331 6.22045 7.60075 5.40569 8.43641C5.38662 8.45601 5.36408 8.47205 5.32941 8.52016C5.35368 8.53263 5.38142 8.54154 5.39875 8.55936C6.22045 9.40214 7.04041 10.2467 7.86211 11.0913C8.01466 11.2481 8.04586 11.4655 7.91932 11.6134C7.79103 11.7648 7.66969 11.9287 7.47553 12C7.42526 12 7.37672 12 7.32818 12Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevYear);
export default __webpack_public_path__ + "static/media/prevYear.0c63effe2c1582b965e5d1b03dc15c09.svg";
export { ForwardRef as ReactComponent };